var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"d-md-inline username-label"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"username"},[_c('avatar',{attrs:{"user":_vm.$store.state.user,"size":"xxs2"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }